// @ts-nocheck
/* eslint-disable no-undef */
window.addEventListener('load', () => {
    const topbar = document.querySelector('finn-topbar');
    topbar?.addEventListener('new-ad', () => {
        if (window.finnAnalytics) {
            window.finnAnalytics.trackEventLater({
                analyticsName: 'new-ad.create-new-ad.global-menu',
                eventKpi: 'effect',
            });
        }
    });
    topbar?.addEventListener('login', () => {
        if (window.finnAnalytics) {
            window.finnAnalytics.trackEventLater({
                analyticsName: 'user-admin.log-in.intentional-login',
                eventKpi: 'action',
                stringValue: 'topbar',
                eventFlags: 'start',
            });
        }
        if (window.finnPulseClient) {
            window.finnPulseClient.trackEvent({
                type: 'Click',
                intent: 'Login',
                name: 'Log in',
                object: {
                    id: 'header-login-link',
                    type: 'UIElement',
                    elementType: 'Link',
                },
                target: {
                    id: '/auth/login',
                    type: 'Form',
                    name: 'Log in',
                },
            });
        }
    });
});
